import { render } from "./BooleanConfig.vue?vue&type=template&id=d87e6f48&ts=true"
import script from "./BooleanConfig.vue?vue&type=script&lang=ts"
export * from "./BooleanConfig.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/soctio/singlepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__